var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-item"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"thumb"}),_vm._m(0),_c('div',{staticClass:"options",on:{"click":_vm.addRecipe}},[_vm._v("+")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('span',{staticClass:"title"},[_vm._v("No meal scheduled")])])
}]

export { render, staticRenderFns }